module.exports = __webpack_public_path__ + "static/media/machineimage.4bbc0375.svg";